import * as React from 'react';
import styled from 'styled-components';
import {
  compose,
  space,
  color,
  layout,
  typography,
  SpaceProps,
  ColorProps,
  LayoutProps,
  TypographyProps,
} from 'styled-system';
import { nanoid } from 'nanoid';
export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    title?: any;
  }
>(({ title, ...props }, svgRef) => {
  const [titleId] = React.useState(() => (title ? nanoid() : undefined));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.36 3.476a5.441 5.441 0 015.28 0l6.175 3.43c1.784.99 1.784 3.555 0 4.546l-2.099 1.166v3.506a3.54 3.54 0 01-1.58 2.949m0 0l-1.607 1.069a6.374 6.374 0 01-7.06 0l-1.606-1.07a3.542 3.542 0 01-1.58-2.948v-3.506l-2.098-1.166c-1.784-.99-1.784-3.555 0-4.546l6.174-3.43m-2.995 8.122a.716.716 0 00-.06-.033l-2.431-1.351a1.184 1.184 0 010-2.07l6.174-3.43a4.025 4.025 0 013.906 0l6.174 3.43a1.183 1.183 0 010 2.07l-2.424 1.347a.735.735 0 00-.075.041l-3.675 2.042a4.026 4.026 0 01-3.906 0l-3.683-2.046zm.335 1.807v2.719c0 .712.357 1.375.948 1.77l1.607 1.068a4.957 4.957 0 005.49 0l1.608-1.069a2.125 2.125 0 00.948-1.769v-2.719l-2.659 1.477a5.442 5.442 0 01-5.282 0L6.7 13.405z"
        clipRule="evenodd"
      />
    </svg>
  );
});
export const IconSystemV2TeacherOverviewGraduateHat = styled(SvgComponent)<IconProps>(
  {
    flex: 'none',
    verticalAlign: 'middle',
  },
  compose(space, color, layout, typography)
);
